import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { DepartmentView } from '@/module/Department/DepartmentView';
import { getDepartmentOptions } from '@/module/Department/model/DepartmentQuery';

export const Route = createFileRoute(
  '/_auth/administration/_administration/department/_department/$departmentId/_layout/',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { departmentId } = Route.useParams();
  const { data: department } = useSuspenseQuery(getDepartmentOptions(departmentId));

  return <DepartmentView department={department} />;
}
